window.$ = window.jQuery = require('jquery');
require('vgnav/dist/js/vgnav');
require('vgformsender/dist/js/vegasformsender.min');
require('vgscrollto/dist/js/vegascrollto.min');
require('popper.js/dist/popper.min');
require('bootstrap/dist/js/bootstrap.min');
require('owl.carousel/dist/owl.carousel.min');
require('jquery-nice-select/js/jquery.nice-select.min');
require('@fancyapps/fancybox/dist/jquery.fancybox');
require('inputmask');
require('jquery.scrollbar/jquery.scrollbar');
require('ion-rangeslider/js/ion.rangeSlider.min');
require('jquery-toast-plugin/dist/jquery.toast.min');


require('../../vendor/dropdown/jquery.vegasDropdown');
require('../../vendor/form-sender/js/jquery.inputmask');
require('../../vendor/form-sender/js/jquery.vegasFormSender');
require('../../vendor/form-sender/js/alert.vegasFormSender');
require('../../vendor/sidebar/vgsidebar');

require('./modules/bg');
require('./modules/owl');
require('./modules/modal');
require('./modules/vegas');
require('./modules/ym');
require('./functions');

require('./modules/shop/shop');
require('./modules/shop/cart');
require('./modules/shop/fav');
require('./modules/shop/filters');
require('./modules/shop/images');
require('./modules/auth');

// [[vegas]]


require('./custom');
